import React from "react";
import PaymentBatches from "../components/PaymentBatches/PaymentBatches";

const PaymentBatchesPage: React.FC = () => {
  return (
    <>
      <PaymentBatches />
    </>
  );
};

export default PaymentBatchesPage;
